<template>
  <div class="warehouse-label">
    <div class="warehouse-label-page" v-for="(item, index) in printData" :key="index">
      <div class="warehouse-label-shelf-number">
        <div class="warehouse-label-shelf-number-text">{{ getShelfNumber(item) }}</div>
      </div>
      <div class="warehouse-label-grid-number">{{ getGridNumber(item) }}</div>
      <img class="warehouse-label-qr-code" :src="item.url" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    printData: { type: Array }
  },
  mounted() {
    this.getQRcode()
  },
  methods: {
    // 二维码内容与现有库位打印规则保持一致。
    getQRcode() {
      this.printData.forEach((item, index) => {
        this.$QRCode.toDataURL(
          `${item.floor_number}-${item.print_index || index + 1}`,
          { errorCorrectionLevel: 'L', margin: 0, width: 512 },
          (err, url) => {
            if (err) throw err
            item.url = url
            this.$forceUpdate()
          }
        )
      })
    },
    // 原唛头顶部显示“区域用途编码-货架编号”。
    getShelfNumber(item) {
      return [item.area_type_code, item.shelf_number].filter(Boolean).join('-')
    },
    // 库位编号只显示“】-”后的实际编号。
    getGridNumber(item) {
      if (!item.grid_number) return ''
      const gridNumber = String(item.grid_number)
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-label {
  color: #000;
}

// 原唛头按打印窗口 33% 缩放后约为 350px × 529px，与历史版式一致。
.warehouse-label-page {
  position: relative;
  box-sizing: border-box;
  width: 1060px;
  height: 1602px;
  margin: 60px;
  border: 8px solid #000;
  background: #fff;
  page-break-after: always;
}

.warehouse-label-shelf-number {
  position: absolute;
  top: 0;
  left: 0;
  display: table;
  box-sizing: border-box;
  width: 100%;
  height: 400px;
  border-bottom: 8px solid #000;
}

.warehouse-label-shelf-number-text {
  display: table-cell;
  padding: 40px;
  font-size: 96px;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  vertical-align: middle;
  overflow-wrap: anywhere;
}

.warehouse-label-grid-number {
  position: absolute;
  top: 700px;
  left: 0;
  width: 100%;
  font-size: 200px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}

.warehouse-label-qr-code {
  position: absolute;
  top: 1030px;
  left: 385px;
  width: 290px;
  height: 290px;
}

@media print {
  .warehouse-label-page {
    position: relative !important;
    width: 1060px !important;
    height: 1602px !important;
    min-height: 1602px !important;
    max-height: 1602px !important;
    margin: 60px !important;
    overflow: hidden !important;
    page-break-inside: avoid;
    page-break-after: always;
  }

  // 公共打印工具会注入 div { height:auto!important; padding:0 }，这里恢复原唛头尺寸。
  .warehouse-label-shelf-number {
    height: 400px !important;
  }

  .warehouse-label-shelf-number-text {
    padding: 40px !important;
  }
}

</style>
